<!--
 * @Author: v_aydwang
 * @Date: 2022-12-23 10:36:56
 * @LastEditors: v_aydwang
 * @LastEditTime: 2023-01-10 14:43:25
 * @Description: 大屏-技能履历弹窗
-->
<template>
  <div class="mantle" v-if="detailVisible">
    <div id="detailsModal">
      <div class="title">技能履历</div>
      <div class="basic-resume">
        <div class="sub-title">项目信息</div>
        <div class="basic-top">
          <div class="top-left">
            <p class="con">当前项目信息</p>
            <p class="con-left">
              <span class="con-right">岗位角色：</span>{{ form.employee_type }}
            </p>
            <p class="con-left">
              <span class="con-right">当前项目：</span>{{ form.project_name }}
            </p>
          </div>
          <div class="top-right">
            <p class="con">历史项目信息</p>
            <div class="list-wrap">
              <div v-if="messageList.length === 0" class="emptyBox">
                <img src="~@/assets/personnel-large/emptyData.png" alt="" />
                <div class="listEmpty">暂无历史项目信息</div>
              </div>
              <div v-else-if="messageList.length <= defaultOption.limitMoveNum">
                <ul id="con1">
                  <li v-for="(item, index) in messageList" :key="index">
                    <p class="con-left">
                      <span class="con-right">{{ item.statis_time }}</span
                      >{{ item.project_name }}
                    </p>
                  </li>
                </ul>
              </div>
              <div v-else>
                <vue-seamless-scroll
                  ref="wrapper"
                  :data="messageList"
                  :class-option="defaultOption"
                >
                  <div ref="scrollList">
                    <ul id="con1">
                      <li v-for="(item, index) in messageList" :key="index">
                        <p class="con-left">
                          <span class="con-right">{{ item.statis_time }}</span
                          >{{ item.project_name }}
                        </p>
                      </li>
                    </ul>
                  </div>
                </vue-seamless-scroll>
              </div>
              <ul id="con2"></ul>
            </div>
          </div>
        </div>
        <div class="sub-title">作业情况</div>
        <div class="basic-bottom">
          <div class="basic-warp">
            <div v-if="workDetailsList.length === 0" class="emptyBox">
              <img src="~@/assets/personnel-large/emptyData.png" alt="" />
              <div class="subEmpty">暂无作业情况记录</div>
              <!-- <a-timeline>
             <a-timeline-item>
                     <Icon :component="Dot" slot="dot" class="icon" />
                    <div class="timeline-box">
                      <p class="timeline-top">
                        <span class="timeline-title"> - 至 -</span
                        > -
                      </p>
                      <div class="timeline-mid">
                        <p>
                          <span>是否初次在当前产线作业：</span> -
                        </p>
                        <p><span>作业总时长：</span>0h</p>
                        <p><span>达标周期：</span>
                          - </p>
                      </div>
                      <div class="timeline-bot">
                        <div class="bot-left">
                          <div class="con-box">
                            <p class="con2">综合得分</p>
                            <p class="number">0</p>
                          </div>
                          <div>
                            <p class="con2">绩效分数</p>
                            <div class="con2-box">
                              <p><span>效率：</span>0</p>
                              <b></b>
                              <p><span>产量：</span>0</p>
                              <b></b>
                              <p><span>质量：</span>0</p>
                              <b></b>
                              <p><span>时长：</span>0</p>
                            </div>
                          </div>
                        </div>
                        <div class="bot-right">
                          <div class="con-box">
                            <p class="con2">评价</p>
                            <p class="con3">-</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a-timeline-item>
            </a-timeline> -->
            </div>
            <div v-else>
              <vue-seamless-scroll
                ref="wrapper"
                :data="workDetailsList"
                :class-option="defaultOption"
              >
                <div ref="scrollList">
                  <a-timeline>
                    <a-timeline-item
                      v-for="(item, index) in workDetailsList"
                      :key="index"
                    >
                      <Icon :component="Dot" slot="dot" class="icon" />
                      <div class="timeline-box">
                        <p class="timeline-top">
                          <span class="timeline-title">
                            {{ item.start_time || "-" }} 至
                            {{ item.end_time || "-" }}</span
                          >{{ item.product_line_name || "-" }}
                        </p>
                        <div class="timeline-mid">
                          <p>
                            <span>是否初次在当前产线作业：</span
                            >{{ item.is_first_work ? "是" : "否" }}
                          </p>
                          <p>
                            <span>作业总时长：</span>{{ item.sum_hs || 0 }}h
                          </p>
                          <p v-if="item.is_first_work">
                            <span>达标周期：</span>
                            {{
                              item.standard_period
                                ? `${item.standard_period} 天`
                                : "-"
                            }}
                          </p>
                        </div>
                        <div class="timeline-bot">
                          <div class="bot-left">
                            <div class="con-box">
                              <p class="con2">综合得分</p>
                              <p class="number">{{ item.avg_score || 0 }}</p>
                            </div>
                            <div>
                              <p class="con2">绩效分数</p>
                              <div class="con2-box">
                                <p>
                                  <span>效率：</span>{{ item.xl_score || 0 }}
                                </p>
                                <b></b>
                                <p>
                                  <span>产量：</span>{{ item.cl_score || 0 }}
                                </p>
                                <b></b>
                                <p>
                                  <span>质量：</span>{{ item.zl_score || 0 }}
                                </p>
                                <b></b>
                                <p>
                                  <span>时长：</span>{{ item.hs_score || 0 }}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="bot-right">
                            <!-- <div class="con-box">
                            <p class="con2">供应商产线排名</p>
                            <p class="number">
                              {{ item.ranking }}<span>/{{ item.rank }}</span>
                            </p>
                          </div>
                          <div class="con-box">
                            <p class="con2">产线排名</p>
                            <p
                              class="rank"
                              :style="
                                ` background: url( ${rankingImage[1]} ) no-repeat;background-size:100% 100%; `
                              "
                            ></p>
                          </div> -->
                            <div class="con-box">
                              <p class="con2">评价</p>
                              <p class="con3">{{ item.evaluation }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a-timeline-item>
                  </a-timeline>
                </div>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
      </div>
      <slot name="close"></slot>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from '../../../components/vueSeamlessScroll';
import Icon from 'ant-design-vue/es/icon';
import Dot from '../../../assets/personnel-large/dot.svg';
import { bus } from '../../personnel-portrait/personnel-portrait-overview/overviewConfig';

export default {
  props: {
    detailVisible: {
      type: Boolean,
      default: false,
    },
    messageList: {
      type: Array,
      default: () => [],
    },
    workDetailsList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    vueSeamlessScroll,
    Icon,
  },
  watch: {
    detailVisible(newVal) {
      if (newVal) {
        this.getDetails();
      }
    },
  },
  data() {
    return {
      Dot,
      rankingImage: {
        1: require('../../../assets/personnel-large/rank1.png'),
        2: require('../../../assets/personnel-large/rank2.png'),
        3: require('../../../assets/personnel-large/rank3.png'),
        4: require('../../../assets/personnel-large/rank4.png'),
        5: require('../../../assets/personnel-large/rank5.png'),
      },
      defaultOption: {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 0, // 单步运动停止的时间(默认值1000ms)
        timer: null, // 定时器
        startDelay: 2000, // 开启滚动的延时
        restartOnDataChange: true, // 数据变更时，从头滚动
      },
      form: {},
    };
  },
  mounted() {
    bus.$on('projectInfo', (data) => {
      this.form = { ...data };
    });
  },
  methods: {
    getDetails() {},
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/convert-viewport";
@import "@/styles/personalDetails";
.mantle {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
}
#detailsModal {
  padding: vw(20) vh(28);
  top: vh(58);
  width: vw(1280);
  height: vh(680);
  .title {
    font-size: vw(24);
    line-height: vh(36);
  }
  .basic-resume {
    .sub-title {
      font-size: vw(20);
      line-height: vh(28);
      margin: vh(20) 0 vh(12) vw(14);
    }
    .basic-top {
      .top-left {
        width: vw(520);
        height: vh(177);
        margin-right: vw(18);
        padding: vh(20) 0 0 vw(36);
      }
      .top-right {
        width: vw(700);
        height: vh(177);
        padding: vh(20) 0 0 vw(36);
        position: relative;
        .emptyBox {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          img {
            height: vh(90);
          }
          .listEmpty {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: vw(14);
            color: #41557b;
            letter-spacing: 0;
            margin-top: vh(10);
          }
        }
      }
    }
    .basic-bottom {
      height: vh(296);
      padding: vh(22) 0 0 vw(22);
      position: relative;
      .basic-warp {
        padding-left: vw(14);
        height: vh(256);
        margin-top: vh(10);
      }
      .icon {
        font-size: vw(28);
      }
      .timeline-box {
        margin-left: vw(10);
        .timeline-top {
          font-size: vw(16);
          line-height: vh(34);
          .timeline-title {
            font-size: vw(16);
            line-height: vh(24);
            margin-right: vw(20);
          }
        }
        .timeline-mid {
          p {
            margin-right: vw(30);
            font-size: vw(14);
            line-height: vh(22);
            span,
            .con2 {
              font-size: vw(14);
              line-height: vh(22);
            }
          }
        }
        .timeline-bot {
          .bot-left {
            margin-right: vw(12);
          }
          .bot-left,
          .bot-right {
            width: vw(550);
            height: vh(98);
            padding: vh(14) 0 0 vw(20);
          }
          .con-box {
            margin-right: vw(40);
            .number {
              font-size: vw(32);
              line-height: vh(32);
              span {
                font-size: vw(16);
                line-height: vh(32);
              }
            }
            .rank {
              width: vw(60);
              height: vh(44);
              margin-top: vh(-8);
            }
            .con3 {
              font-size: vw(14);
              line-height: vh(44);
            }
          }
          .con2-box {
            p {
              font-size: vw(20);
              span {
                font-size: vw(14);
              }
            }
            b {
              height: vh(16);
              margin: vh(8) vw(16) 0;
            }
          }
        }
      }
      .emptyBox {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        img {
          height: vh(90);
        }
      }
      .subEmpty {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: vw(16);
        color: #41557b;
        letter-spacing: 0;
        margin-top: vh(10);
      }
    }
    .con {
      font-size: vw(16);
      line-height: vh(24);
    }
    .con-left {
      font-size: vw(14);
      line-height: vh(22);
      .con-right {
        font-size: vw(14);
        line-height: vh(22);
        margin-right: vw(14);
      }
    }
  }
}
.list-wrap {
  height: vh(100);
}
</style>
<style lang="less" scoped>
/deep/.ant-timeline-item-head-custom {
  background: none;
  margin: 3px;
}
/deep/.ant-timeline-item-tail {
  border: 1px solid rgba(22, 91, 236, 0.2);
  margin: 3px 0 0 3px;
}
</style>
